import Component from "@glimmer/component"
import type { Comment } from "@shared/models/comment"
import FindDoc from "cc-frontend/helpers/find-doc"
import { use } from "ember-could-get-used-to-this"

interface Sig {
  Args: {
    comment: Comment
  }
}

export default class PrintCardComment extends Component<Sig> {
  @use commenter = new FindDoc(() => ["user-summary", this.args.comment.attributes.commenterId])

  get commenterName() {
    if (this.commenter.content === null) return ""
    return (
      this.commenter.content.attributes.firstName + " " + this.commenter.content.attributes.lastName
    )
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Print::Lesson::CardComment": typeof PrintCardComment
  }
}
